var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatusComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.286 22.286H1.714V1.715h6.857v5.142a1.72 1.72 0 001.715 1.715h5.142v2.571h1.715V6.857a.78.78 0 00-.258-.6l-6-6a.78.78 0 00-.6-.257h-8.57A1.72 1.72 0 000 1.715v20.57A1.72 1.72 0 001.714 24h8.572v-1.714zm0-20.229l4.8 4.8h-4.8v-4.8z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.714 18.735l-1.973-1.973-1.075 1.074 3.048 3.048 6.095-6.096-1.074-1.074-5.02 5.021z",
    fill: "#ED1B2E"
  })));
}

export default SvgStatusComplete;